function service (name, options = {}) {
  const customActions = options.customActions || []
  const instanceDefaults = options.instanceDefaults || {}
  const hasMany = options.hasMany || []
  const hasMeta = typeof options.hasMeta !== 'undefined' ? options.meta : false
  const hasOne = options.hasOne || []
  const restful = typeof options.restful !== 'undefined' ? options.restful : true
  const version = options.version || 1

  return {
    customActions,
    name,
    instanceDefaults,
    hasMany,
    hasMeta,
    hasOne,
    restful,
    version
  }
}

const services = [
  service('accounts', {
    customActions: [
      'correction',
      'credit',
      'fund'
    ]
  }),
  service('admin-audit', {
    customActions: [
      'filter'
    ]
  }),
  service('amls', {
    instanceDefaults: {
      name: '',
      relationship: '',
      type: '',
      additionalInfo: ''
    }
  }),
  service('asset-statements', {
    instanceDefaults: {
      cashHeld: 0,
      commercialLoans: 0,
      creditCards: 0,
      investments: 0,
      lifePolicies: 0,
      otherAssets: 0,
      otherProperty: 0,
      overdrafts: 0,
      personalEffects: 0,
      privateResidence: 0,
      residentialLoans: 0,
      taxOwed: 0,
      totalAssetValue: 0,
      totalLiabilities: 0,
      totalNetWorth: 0,
      additionalInfo: ''
    }
  }),
  service('auth', {
    restful: false
  }),
  service('bank-accounts', {
    customActions: [
      'check-bank-accounts',
      'check-bank-transfers'
    ],
    instanceDefaults: {
      country: '',
      bank: '',
      accountNumber: '',
      sortCode: '',
      iban: '',
      bic: ''
    }
  }),
  service('bankwires', {
    instanceDefaults: {
      amount: 0,
      bic: '',
      iban: '',
      reference: ''
    }
  }),
  service('directors', {
    instanceDefaults: {
      email: ''
    }
  }),
  service('documents', {
    customActions: ['generate-co-funding']
  }),
  service('experiences', {
    instanceDefaults: {
      name: '',
      titleNumbers: '',
      type: '',
      units: 0,
      description: '',
      developer: '',
      relationship: '',
      inBorrowerName: false,
      hadPlanningPermission: false,
      obtainedPlanningPermission: false,
      planningNumber: '',
      thirdPartyFunders: '',
      address: {
        nameNumber: '',
        addressLine1: '',
        addressLine2: '',
        town: '',
        county: '',
        postcode: '',
        country: ''
      },
      agent: {
        name: '',
        email: '',
        number: '',
        canContact: false
      },
      architect: {
        name: '',
        email: '',
        phone: '',
        canContact: false
      },
      financials: {
        buildCosts: 0,
        developerEquityDeployed: 0,
        gdv: 0,
        grossProfit: 0,
        netProfit: 0,
        otherCosts: 0,
        otherEquityDeployed: 0,
        professionalCosts: 0,
        purchaseCosts: 0,
        purchasePrice: 0,
        totalBorrowings: 0,
        totalFinanceCosts: 0
      }
    }
  }),
  service('facility-drawdowns', {
    instanceDefaults: {
      description: '',
      date: '',
      amount: 0,
      balanceDeployed: 0,
      undrawnBalance: 0
    }
  }),
  service('facility-fees', {
    instanceDefaults: {
      fee: '',
      calculation: '',
      amount: 0,
      chargeOn: '',
      chargeAt: ''
    }
  }),
  service('facility-loans', {
    instanceDefaults: {
      amount: 0,
      interest: 0,
      interestCompounded: false,
      interestServiced: false,
      drawdowns: []
    }
  }),
  service('facilities', {
    instanceDefaults: {
      type: '',
      amount: 0,
      security: '',
      gdv: 0,
      term: 0,
      totalCosts: 0,
      interestRate: 0,
      nonUtilRate: 0,
      nonUtilAdded: true,
      defaultRate: 0,
      defaultCompounded: true,
      capitaliseLoanOnDefault: true,
      defaultEndOfTerm: true,
      defaultDate: '',
      startDate: '',
      projectedRepaymentDate: '',
      fees: [],
      loans: []
    }
  }),
  service('geo-lookup', {
    restful: false
  }),
  service('investment-funding', {
    instanceDefaults: {
      name: '',
      funding: 0
    }
  }),
  service('investment-statements', {
    customActions: ['consolidated', 'pdf', 'push'],
    instanceDefaults: {
      investment: '',
      funding: '',
      date: '',
      type: '',
      credit: 0,
      debit: 0,
      capital: 0,
      interestDue: 0
    }
  }),
  service('investments', {
    customActions: [
      {
        action: 'get-by-share-type',
        method: 'get'
      },
      {
        action: 'opportunities',
        method: 'get'
      },
      {
        action: 'opportunity/:_id',
        method: 'get',
        state: 'opportunity'
      },
      'aggregate-accrued',
      'download-batch-payment-template',
      'download-investor-transactions',
      'download-transactions',
      'export-investors-as-csv',
      'import-batch-payment',
      'pay-investor'
    ],
    instanceDefaults: {
      title: '',
      projectType: '',
      paymentSchedule: '',
      startDate: '',
      endDate: '',
      intro: '',
      projectOverview: '',
      exitStrategy: '',
      securityDescription: '',
      address: {
        addressLine1: '',
        addressLine2: '',
        town: '',
        county: '',
        postcode: ''
      },
      rounds: [],
      valuation: {
        valuer: '',
        amount: 0,
        date: ''
      },
      totalLoan: 0,
      costPerShare: 0,
      defaultInterestRate: 0,
      ltv: 0,
      securityType: '',
      securityValue: 0,
      loanStartedAt: '',
      loanTerm: 0,
      approved: false,
      published: false
    },
    hasMany: [
      'documents',
      'rounds'
    ]
  }),
  service('kyc', {
    customActions: [
      {
        action: 'statuses',
        method: 'get'
      },
      {
        action: 'types',
        method: 'get'
      }
    ],
    instanceDefaults: {
      user: '',
      document: '',
      type: ''
    }
  }),
  service('notes', {
    instanceDefaults: {
      content: '',
      tag: ''
    }
  }),
  service('storage', {
    restful: false
  }),
  service('payment-types'),
  service('project-funding', {
    instanceDefaults: {
      name: '',
      lender: '',
      charge: '',
      amount: 0,
      totalCosts: 0,
      interestRate: 0,
      term: 0
    }
  }),
  service('projects', {
    instanceDefaults: {
      user: '',
      name: ''
    },
    hasMany: [
      'documents',
      'funding',
      'notes',
      'reviews',
      'securities'
    ]
  }),
  service('reviews', {
    instanceDefaults: {
      tag: '',
      content: '',
      status: 'Pending'
    }
  }),
  service('roles'),
  service('securities', {
    instanceDefaults: {
      name: '',
      charge: '',
      amount: 0
    }
  }),
  service('shares', {
    customActions: [
      'allocate',
      'dissolve',
      'download-breakdown',
      'investor',
      'refinance',
      'simulate-accrued',
      'trail',
      'transfer'
    ]
  }),
  service('share-audit', {
    customActions: [
      'trail'
    ]
  }),
  service('share-transfers'),
  service('shareholders', {
    instanceDefaults: {
      email: '',
      percentageShare: 0
    }
  }),
  service('simulations', {
    instanceDefaults: {
      name: '',
      tag: '',
      term: 0,
      gdv: 0,
      costs: 0,
      coverLimit: 0,
      totalHeadroom: 0,
      totalReturn: 0,
      funding: [],
      securities: []
    }
  }),
  service('statements'),
  service('support-articles', {
    instanceDefaults: {
      title: '',
      content: '',
      published: false
    }
  }),
  service('support-messages'),
  service('transactions', {
    customActions: [
      'check',
      'refund'
    ]
  }),
  service('user-account'),
  service('user-appropriateness', {
    customActions: [
      'decision'
    ]
  }),
  service('user-cards'),
  service('user-investments', {
    customActions: [
      'get-user-portfolio',
      'get-user-portfolio-for-investment'
    ]
  }),
  service('user-profile', {
    instanceDefaults: {
      firstName: '',
      lastName: '',
      isCompany: false,
      preferences: {
        optInMarketing: false
      }
    }
  }),
  service('users', {
    customActions: [
      {
        action: 'borrowers',
        method: 'get'
      },
      {
        action: 'documents',
        method: 'get'
      },
      {
        action: 'investors',
        method: 'get'
      },
      'activate',
      'check-verification',
      'generate-investor-certificate',
      'resend-email-verification',
      'wallet-details'
    ],
    hasMeta: true,
    instanceDefaults: {
      email: ''
    }
  }),
  service('valuations', {
    instanceDefaults: {
      valuation: '',
      date: ''
    }
  }),
  service('withdrawals', {
    instanceDefaults: {
      bankAccount: '',
      amount: 0
    }
  })
]

export default services
